import type { CellContext, ColumnDef } from '@tanstack/react-table';
import { AUTO_COL_WIDTH } from '~/components2/Table';
import type { UtilityAgency } from '~/pages/projectDetails/utilitiesV2/common';
import store from '../../../../store';

const renderCell = ({ getValue }: CellContext<UtilityAgency, unknown>) => {
  const v = getValue<boolean>();
  if (v) {
    return <div className="flex w-full items-center justify-center">✅</div>;
  }
  return null;
};

export const columns: ColumnDef<UtilityAgency>[] = [
  {
    header: 'Agency',
    accessorKey: 'agencyName',
    size: AUTO_COL_WIDTH,
  },
  {
    header: 'Asset',
    accessorKey: 'type',
    size: 75,
  },
  {
    header: 'Maps',
    accessorFn: (a) => store.formState.mapsSelection.has(a.id),
    cell: renderCell,
    size: 50,
  },
  {
    header: 'As-Builts',
    accessorFn: (a) => store.formState.asbuiltsSelection.has(a.id),
    cell: renderCell,
    size: 100,
  },
];
